// #if DIM2
export enum FeatureType {
    Vertex,
    Face,
    Unknown,
}
// #endif

